const TRANSLATION = {
  buyModal: {
    afterFree: 'Nakon vaše besplatne probne perioda',
    btn: 'Probajte besplatno',
    freeTrial: '3-dnevna besplatna probna verzija',
    monthLabel: 'mjesec',
    selectLabel: 'Odaberite plan',
    title: 'Plan pretplate',
    yearLabel: 'godina',
  },
  contact: {
    block1:
      'Za prilagodbu, pitanja ili predloge, molimo kontaktirajte nas na contact@noam.tools. Odgovorit ćemo brzo.',
    block2: 'Podržite nas tako što ćete nas ocijeniti u trgovini Google Apps Extension s ★★★★★.',
    block3: 'Pomožite drugima dijeljenjem ove ekstenzije:',
    title: 'Kontaktirajte nas',
  },
  help: {
    AquickOverviewOfNoam: 'Brzi pregled o Noamu',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Upravljanje omiljenim stavkama',
    Fixedplugin: 'Popravljeni Dodatak',
    Focusing: 'Fokusiranje',
    Free: 'Besplatan',
    FreeTrialBenefits: 'Prednosti besplatnog probnog razdoblja',
    GoWithWikipedia: 'Idi s Wikipedijom',
    GoWithYouTube: 'Idi s YouTubeom',
    HoverTranslation: 'Prevod na lebdanju',
    Howtouse: 'Kako koristiti',
    ImageTranslation: 'Prevođenje slika',
    InstantTranslation: 'Brza prijevod',
    Membership: 'Članstvo',
    NoamHelp: 'Noam vam pomaže u prevođenju i sažimanju',
    PDFparallelTranslation: 'Paralelno prevođenje PDF-a',
    ParallelTranslation: 'Paralelno prevođenje',
    SkipAllSteps: 'Preskoči sve korake',
    Summary: 'Sažetak',
    Translation: 'Prevod',
    TryItForFree: 'Probajte besplatno',
    Video: 'Video',
    VideoSummary: 'Sažetak videa',
    VideoTranslation: 'Video prijevod',
    WebSummary: 'Sažetak web stranice',
    WordSelectionTranslation: 'Prijevod izbora riječi',
    benefits: 'Imamo pogodnosti koje čekaju samo tebe!',
    dayFree: '3-dnevna besplatna probna verzija',
    done: 'Gotovo',
    next: 'Sljedeće',
    pin: 'Prikači Noama za lakši pristup～～',
    planIsNotExist: 'Plan nije dostupan',
    startWiki: 'Započnimo s Wikipedijom!',
    startYoutube: 'Počnimo s YouTubeom!',
    try: 'Isprobajte to',
    tryNow: 'Probajte sada!',
  },
  home: {
    PDFTranslate: {
      desc: 'Dvjezicna prevodjenja + Chat PDF',
      sub1: {
        desc: 'Dvujezično čitanje vam omogućava usporedbu izvornog teksta i prijevoda strana uz stranu, poboljšavajući učinkovitost čitanja.',
        title: 'Dvjezično čitanje',
      },
      sub2: {
        desc: 'Umjetna inteligencija analizira i sažima te može odgovarati na vaše pitanja temeljem sadržaja PDF-a.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI-om pogonjeno prevođenje PDF-a za veću točnost i učinkovitost.',
        title: 'Točnost i učinkovitost',
      },
      title: 'Prevod PDF-a',
    },
    aiAssistant: {
      desc: 'Čineći web prijevod pametnijim i praktičnijim',
      panel1: {
        desc: 'Dvjezične međusobno povezane prijevodi vam pomažu usporediti izvornik s prijevodom kako biste bolje razumjeli i poboljšali učinkovitost čitanja.',
        title: 'Dvjezničko prijevod',
      },
      panel2: {
        left: {
          desc: 'Prilikom pregledavanja web stranice, pređite mišem preko sadržaja koji trebate prevesti kako biste vidjeli prijevod.',
          title: 'Prevod na lebdanju',
        },
        right: {
          desc: 'Prilikom pregledavanja web stranice, odaberite tekst koji želite prevesti kako biste vidjeli prijevod.',
          title: 'Prevod odabira teksta',
        },
      },
      panel3: {
        one: {
          desc: 'Prevodite i sažimajte web stranice i video sadržaj bilo kada, bilo gdje, za glatkije iskustvo!',
          title: 'Pokaz i klikni',
        },
        three: {
          desc: 'Veliki jezički model vođen umjetnom inteligencijom osigurava točnost i dosljednost prijevoda za poboljšanu iskustvo čitanja.',
          title: 'AI-vođeno',
        },
        two: {
          desc: 'Puna pokrivenost više jezika, dvojjezično čitanje bez prepreka, prijevod jednim klikom - doživite razliku!',
          title: 'Sveobuhvatniji i praktičniji',
        },
      },
      panel4: {
        tab1: {
          desc: 'Vaš stručnjak za učinkovitost - koristeći ChatGPT, Noam prevodi i sažima sadržaj YouTube videozapisa kako bi vam uštedio vrijeme!',
          key: 'Video',
          title: 'Prevođenje i sažetak videa',
        },
        tab2: {
          desc: 'Kliknite za prevođenje slika prilikom pregledavanja web stranica.',
          key: 'Slika',
          title: 'Prevođenje slika',
        },
        tab3: {
          desc: 'Brzo izvlači ključne informacije s web strana i daje sažetak, poboljšavajući vašu učinkovitost čitanja.',
          key: 'Web',
          title: 'Web Prijevod i Sažetak',
        },
        tag1: 'Jednostavan',
        tag2: 'Efikasan',
        tag3: 'Lako razumljivo',
      },
      title: 'AI Pomoćnik',
    },
    getStart: 'Započni',
    getStartedForFree: 'Započnite besplatno',
    howItWork: {
      desc: 'Noam integra AI modele kako bi korisnicima pružio inteligentno iskustvo u području međujezične prevode i sažetka web stranica, prevode PDF-a i slika te prevode i sažetka videozapisa',
      title: 'Kako to radi',
    },
    lastBlock: { desc: 'Bolji AI prijevod za glatkiji iskustvo čitanja' },
    top: {
      desc: 'Noam je besplatan AI proširenje za preglednik koje vam pomaže u prevođenju i sažimanju web stranica, videozapisa i PDF sadržaja.\nPridružite se Noamu i doživite čaroliju!',
      title1: 'Jedna Magija',
      title2: 'Jedan klik',
    },
    userReviews: {
      desc: 'Recenzije s pet zvjezdica u Chrome Web Store-u',
      title: 'Korisničke recenzije',
    },
  },
  installTips: {
    btn: 'Probajte sada',
    text: 'Instalirajte "Noam Browser Plugin" kako biste otključali više značajki! Međusobno povezivanje web stranica,\n    sažetak web videozapisa i još mnogo toga!',
  },
  locale: {
    af: 'afrikaans',
    am: 'amharski',
    ar: 'arapski',
    as: 'asamski',
    auto: 'Automatsko prepoznavanje',
    az: 'azerbejdžanski',
    ba: 'baškirski',
    bg: 'bugarski',
    bn: 'bangla',
    bo: 'tibetanski',
    bs: 'bosanski',
    ca: 'katalanski',
    cs: 'češki',
    cy: 'velški',
    da: 'danski',
    de: 'Njemački',
    dsb: 'Dolnji sorbski',
    dv: 'divehi',
    el: 'grčki',
    en: 'Engleski',
    es: 'španjolski',
    et: 'eesti',
    eu: 'baskijski',
    fa: 'perzijski',
    fi: 'finski',
    fil: 'filipinski',
    fj: 'fidžijski',
    fr: 'francuski',
    frCA: 'francuski (Kanada)',
    ga: 'irski',
    gl: 'galicijski',
    gom: 'Konkani',
    gu: 'gudžaratski',
    ha: 'hausa',
    he: 'hebrejski',
    hi: 'hindski',
    hr: 'hrvatski',
    hsb: 'Gornji sorbski',
    ht: 'haićanski kreolski',
    hu: 'madžarski',
    hy: 'jermenski',
    id: 'Indonezijski',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'islandski',
    it: 'talijanski',
    iu: 'inuktitut',
    iuLatn: 'Inuktitut (latinski)',
    ja: 'japanski',
    ka: 'gruzijski',
    kk: 'Kazah',
    km: 'kmerski',
    kmr: 'Kurdski (sjeverni)',
    kn: 'kannadski',
    ko: 'korejski',
    ku: 'kurdski (središnji)',
    ky: 'kirgiški',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'litovski',
    lug: 'Ganda',
    lv: 'latvijski',
    lzh: 'Kineski (književni)',
    mai: 'Maithili',
    mg: 'malgaški',
    mi: 'Māori',
    mk: 'makedonski',
    ml: 'malajalamski',
    mnCyrl: 'mongolski (ćirilica)',
    mnMong: 'Mongolski (tradicionalni)',
    mr: 'marathi',
    ms: 'malajski',
    mt: 'malteški',
    mww: 'Hmong Daw',
    my: 'Mjanmar (burmanski)',
    nb: 'norveški',
    ne: 'nepalski',
    nl: 'nizozemski',
    noSearchLang: 'Jezik nije podržan',
    nso: 'Severni sesoto',
    nya: 'Njanja',
    or: 'Odijski',
    otq: 'Querétaro Otomi',
    pa: 'pendžabi',
    pl: 'poljski',
    placeholder: 'Pretraži',
    prs: 'Dari',
    ps: 'paštunski',
    pt: 'portugalski (Brazil)',
    ptPT: 'portugalski (Portugal)',
    ro: 'rumunski',
    ru: 'ruski',
    run: 'Rundi',
    rw: 'kinjarvanski',
    sd: 'sindski',
    si: 'singalanski',
    sk: 'slovački',
    sl: 'slovenački',
    sm: 'samoański',
    sn: 'Shona',
    so: 'Somali',
    sq: 'albanski',
    srCyrl: 'srpski (ćirilica)',
    srLatn: 'Srpski (latinica)',
    st: 'sesotho',
    sv: 'švedski',
    sw: 'svahili',
    ta: 'tamilski',
    te: 'telugu',
    th: 'tajlandski',
    ti: 'Tigrinja',
    tk: 'Turkmenac',
    tlhLatn: 'Klingonski (latiničnim pismom)',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'setsvana',
    to: 'tonganski',
    tr: 'turski',
    tt: 'Tatar',
    ty: 'tahitanski',
    ug: 'Ujguri',
    uk: 'ukrajinski',
    ur: 'urdski',
    uz: 'uzbèčki (latinica)',
    vi: 'Vijetnamski',
    xh: 'Xhosa',
    yo: 'joruba',
    yua: 'jukatečki maja',
    yue: 'Kantonski (tradicionalni)',
    zh: 'kineski',
    zhHans: 'Kineski pojednostavljeni',
    zhHant: 'Tradicionalni kineski',
    zu: 'Zulu',
  },
  login: {
    and: 'i',
    btn: 'Prijava putem Google-a',
    btn1: 'Prijavite se sada',
    desc: 'Prijavite se kako biste otključali više iskustava',
    policy: 'Politika privatnosti',
    terms: 'Uvjeti korištenja',
    tips: 'Prijavljujući se, slažem se s',
    title: 'Dobrodošli u Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Prati', twitter: 'Twitter' },
    legal: { policy: 'Politika privatnosti', terms: 'Uvjeti usluge', title: 'Pravni' },
    product: {
      image: 'Prevod slike',
      pdf: 'Prevođenje PDF-a',
      title: 'Proizvodi',
      video: 'Prevođenje i sažetak videa',
      web: 'Prevođenje i sažetak web stranica',
    },
    resources: { title: 'Resursi' },
    tools: { title: 'Alati', pdf: 'Prevod PDF-a' },
  },
  pageHeader: {
    contact: 'Kontakt',
    help: 'Pomoć',
    logout: 'Odjava',
    logoutSucc: 'Odjavljeni ste.',
    pricing: 'Cijene',
    settings: 'Postavke',
    signUp: 'Prijava',
  },
  pdf: {
    autoDetect: 'Automatsko prepoznavanje',
    cancelBtn: 'Otkaži',
    cancelUpload: 'Otkaži',
    chatPdf: {
      summaryError: 'Sumarizacija nije uspjela, pokušajte ponovno kasnije',
      chatError: 'Chat nije uspio, pokušajte ponovno kasnije',
      Search: 'Pretraživanje',
      cancel: 'Otkaži',
      chatTitle: 'Dobrodošli u Noam! Evo sažetka vašeg PDF-a:',
      clear: 'Jasno',
      clearContent:
        'Ovo će započeti novu konverzaciju. Trenutna konverzacija neće biti spremljena. Jeste li sigurni?',
      clearDialogTitle: 'Molimo potvrdite',
      clearSucc: 'Očistjeno',
      copy: 'Kopiraj',
      copySucc: 'Kopirano',
      delete: 'Izbriši',
      deleteCancel: 'Otkaži',
      deleteContent: 'Ovaj PDF ne može se oporaviti nakon brisanja. Jeste li sigurni?',
      deleteOk: 'Izbriši',
      deleteSuccess: 'Izbrisano',
      deleteTitle: 'Potvrdi brisanje',
      expand: 'Srušenje',
      historyTitle: 'Povijest',
      listError:
        'Nije moguće učitati listu za čitanje. Pokušajte ponovo kasnije ili se obratite podršci.',
      loading: 'Učitavanje...',
      noDataDesc: 'Još nema povijesti.',
      noMore: 'Više nema sadržaja.',
      placeholder: 'Postavite bilo što o ovom PDF-u',
      summaryTitle: 'Možda ćete biti zainteresirani za ove pitanja:',
    },
    collectionEmpty: 'Vaša kolekcija je prazna.',
    collectionTab: 'Bilješke',
    dataLoading: 'Učitavanje...',
    dialogContent: 'Jeste li sigurni da želite obrisati ovo?',
    dialogTitle: 'Molimo potvrdite',
    download: {
      both: 'dvojezičan',
      btn: 'Spremi',
      cancel:
        'Zatvaranje ovog prozora poništat će preuzimanje PDF-a. Jeste li sigurni da želite poništiti?',
      desc: 'Spremi na uređaj: Preuzima prijevode kao slike; Spremi i isprintaj: Preuzima prijevode u izvornom formatu, s podrškom za kopiranje.',
      download: 'Preuzmi',
      downloadMsg1: 'Napredak prevoda PDF-a:',
      downloadMsg2: 'Procjenjeno preostalo vrijeme:',
      downloadSucc: 'PDF je spreman! Kliknite za spremanje.',
      downloadTip:
        'Preuzimanje PDF-a. Nemojte zatvarati ovaj prozor kako biste izbjegli greške u preuzimanju.',
      error: 'Spremanje nije uspjelo. Pokušajte umjesto toga ispisati.',
      fileName: 'Naziv datoteke:',
      fileType: 'Vrsta datoteke:',
      loading: 'Spremanje...',
      loading2: 'Učitavanje...',
      minute: 'Minute...',
      msg1: 'Neke prijevode u ovom dokumentu su duži od izvornog teksta i mogu se preklapati u preuzetom datoteci. Preporučujemo čitanje na web stranici.',
      msg2: 'Prevođenje još nije završeno. Molimo preuzmite nakon što prevođenje završi.',
      msg3: '2. Neke prevode su preduge. Čitajte na web stranici kako biste izbjegli preklapanje teksta.',
      msg4: 'Prevođenje zadataka je u tijeku. Molimo pokušajte ponovno nakon što se završe.',
      progress:
        'Prevođenje PDF-a. Napredak: {{progress}}, Procjenjeno preostalo vrijeme: {{minutes}} minuta...',
      save: 'Spremi na uređaj',
      savePrint: 'Spremi i isprintaj',
      success: 'Preuzeto',
      trans: 'Samo prijevod',
      transContinue: 'Nastavite s prevođenjem',
    },
    downloadBtn: 'Preuzmi',
    dragTipModal: {
      black: 'svemir',
      leftKey: 'lijeva tipka',
      ok: 'Razumijem',
      press: 'Tisk',
      tips: 'prevlačiti i gledati',
    },
    entry: 'PDF-ovi',
    fileErrMsg:
      'Čitanje datoteke nije uspjelo. Molimo pokušajte ponovno kasnije ili kontaktirajte podršku.',
    fileMsg: 'Trenutna veličina datoteke:',
    fileMsg2: 'Molimo učitajte datoteku manju od 300MB.',
    freeBannerBtn: 'Upgrade',
    freeBannerTips: 'Dosegnut je limit besplatnih prevoda PDF-a',
    guide: {
      placeholder: 'Zalijepite vezu na PDF ovdje',
      start: 'Počni s prevodom',
      text1: 'Dvjezično čitanje',
      text2:
        'Čitaj dvjema jezicima kako bi usporedio izvornik i prijevod uzajamno, povećavajući svoju učinkovitost.',
      text3: 'Razgovarajte s vašim PDF-om',
      text4:
        'Analiza i sažimanje podržano umjetnom inteligencijom. Postavite pitanja o vašem PDF-u i dobijte trenutne odgovore.',
      text5: 'Točan i učinkovit',
      text6: 'Prevođenje PDF-a s podrškom umjetne inteligencije za veću točnost i učinkovitost.',
      title1: 'Dvjezično prijevod',
      title2: 'Razgovarajte s vašim PDF-om',
      toast: 'Unesite valjanu online PDF poveznicu koja završava s .pdf',
    },
    hasTransTask: 'Prevođenje je u tijeku. Molimo pričekajte.',
    hoverTrans: 'Paragrafi s prevodom na prelaz miša',
    initial: 'Prevedi PDF',
    installText: 'Vaše sve u jednom rješenje za svakodnevne prijevode.',
    installText2: 'Prvo instalirajte proširenje',
    installTips: 'Instaliraj proširenje za još više prevoda PDF-a i glatkije prevode web stranica:',
    kw: 'glava',
    link: 'link',
    listError:
      'Nije moguće učitati PDF datoteke. Molimo pokušajte ponovno kasnije ili kontaktirajte podršku.',
    memoTotalCount: 'ukupno 1 stavka',
    new: 'novi datoteka',
    noId: 'ID datoteke nije pronađen.',
    notPdf: 'Samo PDF datoteke.',
    okBtn: 'Izbriši',
    okBtn2: 'Shvatio/la sam',
    original:
      'Vi ste vrlo točan i pouzdan AI dizajniran za generiranje JSON izlaza koji točno odgovara određenom JSON schemi.\n\nMorate slijediti ove pravila:\n1. Strogo se pridržavajte strukture JSON scheme.\n2. Točno podudarajte sve vrste podataka, obavezna polja i ograničenja.\n3. NE uključujte nikakav dodatni tekst, objašnjenje, markdown ili komentare.\n4. Ispišite SAMO JSON objekt — bez blokova koda, bez uvodnog teksta, bez omotanja.\n\nInformacije o schemi su navedene u nastavku.\n- Naziv scheme: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Paralelan',
    parseErrDialogContent:
      'Ovaj PDF link ne može se prevesti izravno. Preuzmite PDF i postavite ga za prevođenje.',
    parseErrTips: 'Neuspješno parsiranje datoteke',
    parseFileToast:
      'Neuspješno parsiranje datoteke. Pokušajte ponovno kasnije ili se obratite podršci.',
    pdfLoading: 'Parsiranje...',
    searchPlaceholder: 'Pretraga',
    selectTrans: 'Odaberite tekst za prijevod',
    shareBtn: 'Podijeli',
    shareBtnText1: 'Generiraj poveznicu za dijeljenje',
    shareBtnText2: 'Ažuriraj dijeljeni sadržaj',
    shareModal: {
      cancel: 'Otkaži',
      copy: 'Kopiraj',
      copySucc: 'Link kopiran',
      custom: 'Prilagodite:',
      errMsg: 'Odabrani sadržaj još nije potpuno preveden. Molimo prevedite prije dijeljenja.',
      gen: 'Podijeli',
      modify: 'Uredi',
      notSupport: 'Ovaj jezik trenutno nije podržan.',
      page: 'Stranice',
      pageNuErr: 'Unesite ispravan broj stranice.',
      range: 'Opseg:',
      remain: 'preostali',
      remain1: 'Ukupno procjenjeno vrijeme:',
      search: 'Pretraga',
      settings: 'Postavke dijeljenja:',
      shareSetting: 'Postavke dijeljenja',
      shareText: 'Podijeli',
      shareTips: 'Podijelite poveznicu na prevedeni PDF s prijateljima:',
      sourceLang: 'Od:',
      target: 'Za:',
      text1: 'Postavke dijeljenja',
      text2: 'Generiraj poveznicu za dijeljenje',
      totalPage: 'ukupno 1 stranica',
      trans: 'Prevedi',
      translateTips:
        'Savjet: Ako prevod traje dugo, možete zatvoriti ovaj prozor i podijeliti ga kasnije.',
      translating: 'Prevođenje PDF-a...',
      update: 'Ažuriraj poveznicu za dijeljenje',
    },
    shareMsg1: 'Generirana poveznica za dijeljenje.',
    shareMsg2: 'Dijeljeni sadržaj ažuriran.',
    shareMsg3:
      'Nije moguće generirati poveznicu za dijeljenje. Pokušajte ponovno kasnije ili se obratite podršci.',
    shareMsg4:
      'Neuspješno ažuriranje dijeljenog sadržaja. Pokušajte ponovno kasnije ili kontaktirajte podršku.',
    shareTips: 'Vaš je prijevod PDF-a spreman! Podijelite ga s prijateljima.',
    start: 'Pokrenite besplatnu probnu verziju',
    thumbnail: 'Sadržaj',
    toast1: 'Učitavanje PDF-a. Molimo pokušajte ponovno kasnije.',
    toast2: 'Sadržaj PDF-a se obrađuje. Dijalog trenutno nije podržan.',
    toast3: 'Preuzimanje u tijeku. Pokušajte ponovno nakon što se preuzimanje završi.',
    toolbar: { Adjust: 'Prilagoditi', autoFit: 'Automatsko prilagođavanje' },
    trans: 'Prevod',
    transSucc: 'Prevod uspješan!',
    unLoginToast: 'Prijavite se kako biste koristili ovu značajku.',
    uploadBtn: 'Postavljanje',
    uploadErr: 'Prijenos datoteke nije uspio. Pokušajte ponovno kasnije ili se obratite podršci.',
    uploadErrSignUrl:
      'Nije moguće dobiti URL za upload. Pokušajte ponovno kasnije ili se obratite podršci.',
    uploadMsg1: 'Prevucite i ispustite svoju datoteku ovdje.',
    uploadMsg2: 'Podržani tipovi datoteka: PDF  |  Maksimalna veličina datoteke: 300MB',
    uploadMsg3: 'Kliknite za odabir ili povucite i ispustite datoteke ovdje.',
    uploading: 'Učitavanje',
    uploadingMsg: 'Učitavanje. Molimo pričekajte.',
    uploadingMsg1: 'Datoteka se prenosi. Pokušajte ponovno kasnije.',
    uploadingMsg2: 'Datoteka se trenutno pretvara. Pokušajte ponovno kasnije.',
    uploadingMsg3:
      'Zahtjev za napredak konverzije nije uspio. Pokušajte ponovo kasnije ili se obratite podršci.',
    uploadingMsg4:
      'Noam ne može pristupiti lokalnim datotekama. Molimo ručno postavite PDF za prijevod.',
    uploadingMsg5:
      'Nije moguće dohvatiti URL datoteke. Pokušajte ponovno kasnije ili kontaktirajte podršku.',
    video: 'video',
    vipBannerBtn: 'nadogradnja',
    vipBannerTips: 'Dosegli ste svoj limit prevoda PDF datoteka za ovaj mjesec.',
    webTrans: 'Puna međusadržajna referenca',
  },
  pricing: {
    FAQ: 'Često postavljana pitanja',
    FQAObj: {
      a1: 'Da, Noam nudi besplatan plan koji možete odmah koristiti.',
      a2: 'Pružamo tri plana članstva: Pro, Pro+ i Enterprise. Možete odabrati plaćanje mjesečno ili godišnje. Godišnje računanje nudi značajne uštede.',
      a3: 'Sve značajke dostupne su u oba plana. Glavna razlika je u cijeni: godišnje pretplate ukupno koštaju manje. Mjesečne pretplate se obračunavaju svakog mjeseca, dok se godišnji planovi obračunavaju jednom godišnje.',
      a4: 'Pretplatu možete otkazati bilo kada u Postavkama računa.',
      q1: 'Postoji li besplatan plan?',
      q2: 'Koja cjenovna plaňa i opcije plaćanja su dostupne?',
      q3: 'Koja je razlika između mjesečne i godišnje pretplate?',
      q4: 'Kako otkazem svoju pretplatu?',
    },
    around: 'Okolo',
    billedMonthly: 'Mješecno obračunavanje',
    billedYearly: 'Naplaćuje se godišnje',
    day: 'dan',
    desc: 'Usporedite pakete i odaberite najbolji',
    detailedCompare: 'Usporedi planove',
    discount: '20% popusta',
    enterprise: {
      benefit1: 'Prioritetno podrška kupcima',
      benefit2: 'Više korisnika',
      benefit3: 'Prilagođene Rješenja',
      benefit5: 'Dedicirani menadžer računa',
      btn: 'Kontaktirajte nas',
      recommendText: 'Prilagođeni planovi (≥3 osobe)',
      talkToUs: 'Kontaktirajte nas',
    },
    free: {
      benefit1: 'Brza prevod 100 puta dnevno',
      benefit2: 'Prevođenje i sažetak web stranice',
      benefit3: '30 prevoda slika',
      benefit4: 'Prevođenje i sažetak videozapisa',
      benefit5: '10 prevoda PDF-a',
      benefit6: '5.000 tokena',
      btn: 'Probajte besplatno',
      recommendText: 'Besplatan probni period',
    },
    imageTranslation: 'Prevođenje slika',
    month: 'mjesec',
    monthly: 'Mjesečno',
    pageTitle: 'Cijena',
    pdf: {
      chat: 'Upiti za PDF Chat',
      maxPage: 'Maks. stranica po PDF-u',
      translation: 'Prevođenje PDF-a',
    },
    preMonth: 'Po mjesecu',
    pro: {
      benefit1: 'Prioritetno podrška kupcima',
      benefit2: '1.000.000 tokena/mjesec',
      benefit3: 'Prevođenje i sažetak web stranice',
      benefit4: '200 prevoda slika',
      benefit5: 'Prevođenje i sažetak videa',
      benefit6: '200 prevoda PDF-a',
      btn: 'Započni',
      recommendText: 'Najpopularniji',
    },
    proPlus: {
      benefit1: 'Prioritetna podrška korisnicima',
      benefit2: '3.000.000 tokena/mjesec',
      benefit3: 'Prevođenje i sažetak web stranice',
      benefit4: '500 prijevoda slika',
      benefit5: 'Prevođenje i sažetak videa',
      benefit6: '500 prevoda PDF-a',
      recommendText: 'Najbolja vrijednost',
    },
    video: { summary: 'Sažetak videa', translation: 'Prevođenje videozapisa' },
    web: {
      contrastiveTranslation: 'Dvijenčana prijevod',
      dictionaryTranslation: 'Odabir prijevoda',
      hoverTranslation: 'Hover Prijevod',
      instantTranslation: 'Brza prijevod',
      summary: 'Sažetak web stranice',
    },
    yearly: 'Godišnje',
  },
  privacy: {
    block1:
      'Noam („Noam“, „mi“, „naš“ ili „nama“) poštuje vaše privatnost i predano je zaštiti svih informacija koje dobijemo od vas ili o vama. Ova Politika privatnosti opisuje naše postupke u vezi s prikupljanjem ili korištenjem osobnih podataka iz vašeg korištenja našeg web mjesta, aplikacija i usluga (zajednički „Usluge“). Ova Politika privatnosti ne primjenjuje se na sadržaj koji obrađujemo u ime naših poslovnih kupaca proizvoda, kao što je naš API. Korištenje ovih podataka podliježe našoj ugovornijoj kupcu, koja pokriva pristup i korištenje ovih proizvoda.',
    block10:
      'Primjenjujemo komercijalno razumne tehničke, administrativne i organizacijske mjere za zaštitu online i offline osobnih podataka od gubitka, neovlaštenog korištenja, neovlaštenog pristupa, otkrivanja, izmjena ili neprijateljskih djela. Međutim, nijedna internet ili e-poštanska prijenos ne može garantirati potpunu sigurnost ili točnost. Posebice, e-pošte poslane nam ili iz našeg sustava možda neće biti sigurne. Stoga trebate biti posebno oprezni kada odlučujete koje informacije nam slati putem usluge ili e-pošte. Dodatno, ne smatramo se odgovornima za bilo kakvo ometanje postavki privatnosti ili sigurnosnih mjera u usluzi ili sigurnosnih postavki ili mjera trećih strana na njihovim web stranicama. Čuvati ćemo vaše osobne podatke sve dok je potrebno kako bismo vam pružali usluge ili za druge zakonite poslovne svrhe, kao što su rješavanje sporova, razlozi sigurnosti i bezbednosti ili poštivanje naših zakonskih obaveza. Trajanje čuvanja osobnih podataka ovisit će o mnogim faktorima, kao što su količina, priroda, osjetljivost informacija, potencijalni rizici neovlaštenog korištenja ili otkrivanja, svrhe za koje obrađujemo informacije te druge zakonito obvezujuće razmatranja.',
    block11:
      'Ovu Pravilu o privatnosti možemo ažurirati s vremena na vrijeme. Kada to učinimo, objavit ćemo ažuriranu verziju na ovoj stranici, osim ako to primjena zakona drugačije zahtijeva.',
    block12:
      'Ako imate neodgovorena pitanja ili brige u vezi s ovom Pravilnikom o zaštiti privatnosti, molimo kontaktirajte našu službu za korisnike. E-pošta:',
    block2: 'Sakupljamo sljedeće osobne podatke („Osobni podaci“) koji se tiču vas:',
    block3:
      'Informacije koje ste Vi pružili: Kada kreirate račun za korištenje naših usluga ili komunicirate s nama, prikupljamo osobne informacije kako slijedi:',
    block4:
      'Osobne informacije automatski primljene prilikom korištenja usluga: Kada pristupate, koristite ili komunicirate s uslugama, primljamo sljedeće informacije o vašem pristupu, korištenju ili komunikaciji („Tehničke informacije“):',
    block5: 'Možemo koristiti osobne podatke u sljedećim svrham:',
    block6:
      'Sažetak ili deidentificirani podaci: Možemo agregirati ili deidentificirati osobne podatke kako bismo spriječili njihovo ponovno korištenje u svrhu identifikacije te koristiti takve podatke za analizu učinkovitosti naših usluga, poboljšanje i dodavanje značajki naših usluga, provođenje istraživanja te za slične svrhe. Osim toga, možemo analizirati opće ponašanje i karakteristike korisnika naših usluga te dijeliti agregirane podatke s trećim stranama, objavljivati takve agregirane podatke ili ih činiti općenito dostupnim. Agregirane podatke možemo prikupljati putem usluga, putem kolačića (cookies) i putem drugih načina opisanych u ovoj Pravili o zaštiti privatnosti. Deidentificirane podatke ćemo održavati i koristiti u anonimnoj ili deidentificirano obliku, a nećemo pokušavati ih ponovno identificirati osim ako to ne zahtijeva zakon.',
    block7:
      'U određenim slučajevima možemo dostaviti vaše osobne podatke trećim stranama bez daljnjeg obavještavanja vas, osim ako to zakonom nije zahtijevano:',
    block8:
      'Ovisno o vašoj geografskoj lokaciji, pojedinci u Europskoj gospodarskoj oblasti, Ujedinjenom Kraljevstvu i širom svijeta mogu imati određena zakonska prava u vezi s svojim osobnim podacima. Na primjer, možete imati pravo na:',
    block9:
      'Usluga može sadržavati linkove na druge web stranice koje Noam ne upravlja niti kontrolira, uključujući usluge društvenih medija ("Treće strane web stranice"). Informacije koje dijelite s Trećim stranama web stranica bit će regulirane specifičnim politikama privatnosti i uvjetima usluge tih Trećih strana web stranica, a ne ovom Politikom privatnosti. Ove linkove pružamo radi jednostavnosti i ne podrazumijevamo njihovo preporučivanje ili recenziranje. Za informacije o njihovim politikama privatnosti i uvjetima, kontaktirajte direktno Treće strane web stranice.',
    subBlock1:
      'Informacije o računu: Kad otvorite račun na našoj platformi, prikupljamo informacije povezane s vašim računom, uključujući vaše ime, kontakt informacije, pristupne podatke računa, informacije o plaćanju kartice i povijest transakcija ("Informacije o računu").',
    subBlock10: 'Nudanje, upravljanje, održavanje i/ili analiza usluga;',
    subBlock11: 'Komunikacija s tobom;',
    subBlock12: 'Razvoj novih proizvoda i usluga;',
    subBlock13:
      'Sprječavanje prijevara, kaznenih djela ili zlouporabe naših usluga te zaštita sigurnosti naših IT sustava, arhitekture i mreža;',
    subBlock14: 'Izvođenje premeštaja poslovanja;',
    subBlock15:
      'Usklađivanje sa zakonskim obavezama i pravnim postupcima, zaštita naših prava, privatnosti, sigurnosti ili imovine, kao i onih naših povezanih društava, vas ili drugih trećih strana.',
    subBlock16:
      'Dobavljači i pružatelji usluga: Kako bi nam pomogli u zadovoljenju poslovnih operativnih potreba i obavljanju određenih usluga i funkcija, možemo pružati osobne podatke dobavljačima i pružateljima usluga, uključujući pružatelje hosting usluga, pružatelje cloud usluga, druge pružatelje informacijsko-tehnoloških usluga, softver za e-poštu komunikaciju i pružatelje usluga web analitike itd. Ovi partneri će pristupati, obrađivati ili pohranjivati osobne podatke samo prema našoj uputi dok obavljaju svoje dužnosti za nas.',
    subBlock17:
      'Transferi poslovanja: Ako se uključimo u strateške transakcije, reorganizacije, stečajeve, preuzimanja u stečaju ili prelaz usluga na drugog pružatelja (zajednički "Transakcije"), vaše osobne podatke i druge informacije možemo podijeliti s transakcijskim suparnicima i drugim stranama koje pomažu u provedbi Transakcija tijekom postupka due diligence-a te ih prenijeti kao dio Transakcija zajedno s drugim sredstvima na nasljednika ili povezano poduzeće.',
    subBlock18:
      'Zakonska obveza: Možemo podijeliti vaše osobne podatke s vladinim tijelima, industrijske kolege ili drugim trećim stranama, uključujući podatke o vašem interakciji s našim uslugama, (1) ako to zahtijeva zakon ili ako vjerujemo da je takvo djelovanje potrebno za poštovanje zakonskih obveza; (2) za zaštitu i branu naših prava ili imovine; (3) ako jednostrano utvrdimo da postoji kršenje naših uvjeta, politika ili zakona; (4) za otkrivanje ili sprječavanje prevaranja ili drugih nezakonitih aktivnosti; (5) za zaštitu naših proizvoda, zaposlenika ili korisnika, ili javne sigurnosti, sigurnosti, integriteta; ili (vi) za odbranu od zakonske odgovornosti.',
    subBlock19: 'Pristupite vašoj osobnoj informaciji i informacijama o tome kako se ona obrađuje.',
    subBlock2:
      'Kada koristite naše usluge, prikupljamo osobne podatke iz vaših unosa, postavljanja datoteka ili povratnih informacija koje nam dostavljate („Sadržaj“).',
    subBlock20: 'Zahtijevajte brisanje vaših osobnih podataka iz naših zapisa.',
    subBlock21: 'Ispravite ili ažurirajte vaše osobne podatke.',
    subBlock22: 'Prenosite vaše osobne podatke trećoj strani (prenosivost podataka).',
    subBlock23: 'Ograničite način na koji obrađujemo vaše osobne podatke.',
    subBlock24:
      'Uklonite vašu saglasnost — gdje se oslanjamo na saglasnost kao pravnu osnovu obrade, možete ukloniti saglasnost u bilo kojem trenutku.',
    subBlock25: 'Prigovarati se protiv načina na koji obrađujemo vaše osobne podatke.',
    subBlock26: 'Poboljšanje naših usluga i provođenje istraživanja;',
    subBlock3:
      'Informacije o komunikaciji: Ako nam šaljete poruke, bit ćemo prikupljati vaše ime, kontakt informacije i sadržaj vaših poruka („Informacije o komunikaciji“).',
    subBlock4:
      'Informacije o društvenim mrežama: Imamo stranice na web stranicama društvenih mreža kao što su Instagram, Facebook, Medium, Twitter, YouTube i LinkedIn. Kada interagirate s našim stranicama na društvenim mrežama, prikupljamo osobne podatke koje nam odlučite pružiti, kao što su vaši kontakt podaci („Informacije o društvenim mrežama“). Dodatno, tvrtke koje hostiraju naše stranice na društvenim mrežama mogu nam pružati agregirane informacije i analize o našim aktivnostima na društvenim mrežama.',
    subBlock5:
      'Podaci o dnevniku: Informacije koje automatski šalje vaš preglednik prilikom korištenja naših usluga. Podaci o dnevniku uključuju vašu Internet Protocol (IP) adresu, vrstu i postavke preglednika, datum i vrijeme vaših zahtjeva te način na koji interactirate s našom web stranicom.',
    subBlock6:
      'Podaci o uporabi: Možemo automatski prikupljati informacije o vašem korištenju usluge, kao što su vrste sadržaja koje gledate ili s kojima komunicirate, značajke koje koristite, radnje koje preduzimate, kao i vaša vremenska zona, država, datum i vrijeme pristupa, korisnički agent i verzija, tip računala ili mobilnog uređaja te vaša veza s računalom.',
    subBlock7:
      'Informacije o uređaju: Ovo uključuje ime uređaja, operacijski sustav, identifikator uređaja i preglednik koji koristite. Sakupljena informacija može ovisiti o tipu uređaja koji koristite i njegovim postavkama.',
    subBlock8:
      'Kolačići: Koristimo kolačiće za rad i upravljanje našim uslugama te poboljšanje vaše iskustva. "Kolačić" je informacija koju posjetljena web stranica šalje vašem pregledniku. Možete postaviti svoj preglednik da prihvati sve kolačiće, odbije sve kolačiće ili vas obavijesti kada se dostavi kolačić kako biste svaki put mogli odlučiti hoćete li ga prihvatiti. Međutim, odbijanje kolačića može spriječiti korištenje ili negativno utjecati na prikaz ili funkcionalnost određenih područja ili značajki web stranice. Za više informacija o kolačićima posjetite All About Cookies.',
    subBlock9:
      'Analitika: Možemo koristiti različite online analitičke proizvode koji koriste kolačiće kako bismo analizirali kako korisnici koriste naše usluge i poboljšali vaše iskustvo prilikom korištenja usluga.',
    subTitle1: 'Osobne informacije koje prikupljamo',
    subTitle2: 'Kako koristimo osobne podatke',
    subTitle3: 'Otkrivanje osobnih podataka',
    subTitle4: 'Vaša prava',
    subTitle5: 'Poveznice na druge web stranice',
    subTitle6: 'Sigurnost i zadržavanje informacija',
    subTitle7: 'Izmjena politike privatnosti',
    subTitle8: 'Kako nas kontaktirati',
    title: 'Politika privatnosti',
    updateTime: 'Ažurirano: 15. ožujka 2024.',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Prihvati sve',
    text: 'Da bismo poboljšali vaše iskustvo, koristimo kolačiće za personalizaciju sadržaja i usluga.',
    title: 'Ova web stranica koristi kolačiće',
  },
  slogen: 'Najlakši AI asistent',
  stripe: {
    contact: 'Kontaktirajte nas na contact@noam.tools za bilo kakva pitanja!',
    fail: {
      btn: 'Ponovite',
      text1: 'Nismo mogli obraditi Vašu plaću.',
      text2: 'Provjerite svoju vezu i pokušajte ponovno.',
      title: 'Plaćanje nije uspjelo',
    },
    succ: { btn: 'Idemo', text1: 'Dobrodošli u Noam', text2: 'Počnimo!', title: 'Čestitke' },
  },
  terms: {
    block1: 'Hvala što koristite Noam!',
    block10:
      '(a) Naknade i računiranje. Plaćat ćete sve naknade („Naknade“) prema cijenama i uvjetima na relevantnoj stranici s cijenama ili prema onome što smo dogovorili u pismu. Zadržavamo pravo ispraviti pogreške u cijenama čak i ako smo izdali račune ili primili plaćanje. Osiguravat ćete potpune i točne podatke za računiranje, uključujući valjanu i ovlaštenu metodu plaćanja. Naplatit ćemo vašu metodu plaćanja povremeno prema dogovoru, ali možemo razumno promijeniti datum računiranja. Odobravate Noamu, njegovim pridruženim tvrtkama i trećim procesorima plaćanja da naplate vašu metodu plaćanja. Ako vaše plaćanje ne uspije, dostavit ćemo vam pismeno obavijest i možemo suspendirati pristup Usluzi dok se ne primi plaćanje. Osim ako nije drugačije规定ano u ovom ugovoru, plaćanja nisu povratna.',
    block11:
      '(b) Porezi. Osim ako nije drugačije navedeno, naknade ne uključuju nikakve savezne, državne, lokalne i strane poreze, carine i slične naplate ("Porezi"). Vi ste odgovorni za sve Poreze povezane s vašim kupnjama, isključujući Poreze temeljene na našem neto dohotku za koje ćemo vam izdati račun. Ugovarate se da ćete takve Poreze pravovremeno platiti i dati nam pravno valjane izjave o privatnosti te dobiti potrebna pristupa za rukovanje takvim podacima, te jamčite nam da rukujete takvim podacima u skladu s primjenjivim zakonima.',
    block12:
      '(c) Promjene cijena. Možemo promijeniti naše cijene tako da Vas obavijestimo putem Vašeg računa i/ili naše web stranice. Povećanja cijena stupaju na snagu odmah nakon objave. Sve promjene cijena primjenjuju se na naknade za Vaš račun nakon dana stupanja na snagu promjene.',
    block13:
      '(d) Spori i kašnjeni plaćanja. Ako želite osporiti bilo kakve naknade ili poreze, molimo kontaktirajte contact@noam.tools unutar trideset (30) dana od datuma računa.',
    block14:
      '(e) Besplatna upotreba. Ne smijete stvarati više računa kako biste dobili besplatne kredite. Ako utvrdimo da ne koristite besplatne kredite u dobroj vjeri, možemo vam naplatiti standardne tarife ili prekinuti pristup usluzi.',
    block15:
      '(a) Tajnost. Možete imati pristup tajnim informacijama Noama. Tajne informacije možete koristiti samo onako kako je dopušteno prema ovim uvjetima i isključivo u svrhu korištenja Servisa. Ne smijete otkriti tajne informacije nikome trećoj strani, a morate zaštititi tajne informacije na način koji nije manje zaštitni nego kako zaštitite svoje vlastite slične tajne informacije, barem s razumnom pažnjom. Tajne informacije su nejavne informacije koje Noam označi kao tajne ili koje bi u danim okolnostima razumno trebalo tretirati kao tajne, uključujući softver, specifikacije i druge nejavne poslovne informacije. Tajne informacije ne uključuju informacije koje: (1) postanu općenito dostupne javnosti bez vašeg krivnje; (2) ste posjedovali bez ikakve obveze tajnosti prije nego što ste ih primili prema ovim uvjetima; (3) zakonito otkrije vam treća strana bez ikakvih obveza tajnosti; ili (4) ste sami razvili neovisno, bez korištenja tajnih informacija. Možete otkriti tajne informacije ako to zahtijeva zakon, sudska odluka ili druga vladina naredba, ali morate Noamu dostaviti prethodno pismo obavijest na razuman način i, u mjeri moguće, poduzeti razumne napore da ograničite opseg otkrivanja, uključujući pomoć nam u suprotanju zahtjevima za otkrivanje.',
    block16:
      '(b) Sigurnost. Morate implementirati razumne i prikladne mjere kako biste pomogli zaštititi pristup i korištenje Servisa. Ako otkrijete bilo kakve ranjivosti ili kršenja povezana s vašim korištenjem Servisa, morate neposredno kontaktirati Noama i dostaviti detalje o ranjivosti ili kršenju.',
    block17:
      '(c) Obrada osobnih podataka. Ako koristite Uslugu za obradu osobnih podataka, morate pružati pravno dovoljne izjave o privatnosti i pribaviti potrebna pristupa za obradu takvih podataka, te jamčite nam da obrađujete takve podatke u skladu s primjenjivim zakonima.',
    block18:
      '(a) Prekid; Suspenzija. Ovi uvjeti stupaju u snagu od vašeg prvog korištenja Usluge i ostaju na snazi sve dok se ne prekinu. Vi možete prekinuti ove uvjete u bilo kojem trenutku i iz bilo kojeg razloga prestanak korištenja Usluge i Sadržaja. Mi možemo prekinuti ove uvjete s prethodnom obavještenjem iz bilo kojeg razloga. Možemo odmah prekinuti ove uvjete obavještavajući vas ako ubitno kršite Odjeljak 2 (Zahtjevi za korištenje), Odjeljak 5 (Tajnost, sigurnost i zaštita podataka), Odjeljak 8 (Rješavanje sporova) ili Odjeljak 9 (Opći uvjeti), ili ako se naš odnos s bilo kojim trećim pružateljem tehnologije van našeg kontrole promijeni, ili radi usklađivanja s zakonom ili zahtjevima vlade. Možemo suspendirati vaš pristup Usluzi ako ne postupate u skladu s ovim uvjetima, ili ako vaše korištenje predstavlja sigurnosni rizik za nas ili bilo kojeg trećeg lica, ili ako sumnjamo da je vaše korištenje prevarantno ili može izložiti nas ili bilo kojeg trećeg lica odgovornosti.',
    block19:
      '(b) Učinci prekidanja ugovora. Nakon prekidanja ugovora, prestati ćete koristiti Uslugu i neodgodno vratiti ili uništaviti svaku poverljivu informaciju kako biste to mi naložili. Odredbe ovih uvjeta koje po svojoj prirodi trebaju preživjeti prekidanje ili isteku ugovora, uključujući ali ne ograničavajući se odjeljcima 3 i 5-9, ostaju na snazi.',
    block2:
      'Ovi uvjeti korištenja primjenjuju se na vaše korištenje Noamovih usluga, uključujući naše sučelja za programiranje aplikacija, softver, alate, usluge za developere, podatke, dokumentaciju i web stranicu (zajednički nazvane "Usluge"). Korištenjem naših Usluga slažete se da ćete se pridržavati ovih uvjeta. Naša Politika privatnosti objašnjava kako prikupljamo i koristimo osobne podatke.',
    block20:
      '(a) Odgovornost za preuzimanje gubitaka. Ti ćemo braniti, osigurati i osloboditi nas, naše podružnice i naše osoblje od bilo kakvih zahtjeva, gubitaka i troškova (uključujući odvjetničke honorare) koji proizlaze iz ili se odnose na tvoje korištenje Servisa, uključujući tvoje Sadržaje, tvoje korištenje proizvoda ili usluga povezanih s Servisom te tvoje kršenje ovih uvjeta ili primjenjive zakone.',
    block21:
      '(b) Odricanja od odgovornosti. Usluga se pruža "kao što je". U mjeri dozvoljeno zakonom, mi, naši pridruženi tvrtke i licencionari ne dajemo nikakve predstavljanja ili jamstva u vezi s Uslugom i ne dajemo jamstva, uključujući ali ne ograničavajući se na jamstva trgovivosti, primjenjivosti za određenu svrhu, zadovoljavajuće kvalitete, nekršenja prava i mirnog korištenja, te bilo koja jamstva koja proizlaze iz poslovanja ili uporabe trgovine. Ne jamčimo da će Usluga biti neprekinuta, točna ili bez grešaka, ili da će bilo koji Sadržaj biti siguran, ne izgubljen ili ne promijenjen.',
    block22:
      '(c) Ograničenje odgovornosti. Ni mi, niti naši pridruženi tvrtke, niti naši licenciranja neće biti odgovorni za bilo kakve neizravne, slučajne, posebne, posledične ili kaznene štete, uključujući gubitak profita, gubitak reputacije, gubitak korištenja, gubitak podataka ili druge nematerijalne gubitke, čak i ako smo bili upozoreni na mogućnost takvih šteta. Prema ovim uvjetima, naš ukupni odgovor neće premašiti naknade koje ste platili usluzi u toku dvanaest (12) mjeseci prije podnošenja zahtjeva ili sto američkih dolara ($100), ovisno što je veće. Ograničenja u ovom odjeljku primjenjuju se u najvećoj mjeri dopuštenoj primjenjivim zakonima.',
    block23:
      'Uvjeti i vaše korištenje Usluga reguliraju se zakonima Sjedinjenih Država, osim pravila Sjedinjenih Država o sukobu zakona. Vaše korištenje Aplikacije također može biti podložno drugim lokalnim, državnim, nacionalnim ili međunarodnim zakonima. Sve pravne radnje ili postupci u vezi s ovim Uvjetima podnijet će se isključivo pred sudovima Sjedinjenih Država, a Vi se slažete da se podvrgnete osobnoj jurisdikciji takvih sudova.',
    block24:
      'Odnos strana. Noam i vi ste neovisni ugovornici, te nijedna strana nema ovlasti predstavljati ili obvezati drugu stranu niti preuzeti obveze u ime druge strane bez prethodnog pisanog pristupa drugog strana.',
    block25:
      '(b) Korištenje brenda. Ne smijete koristiti ime, logotipove ili zaštitna znaka tvrtke Noam ili bilo koje od njezinih povezanih tvrtki bez našeg prethodnog pisanskog pristupa.',
    block26:
      'Ako se bilo koja odredba ovih uvjeta utvrdi da je nevažeća, nezakonita ili neizvršiva, preostale odredbe ostaju u potpunoj snazi i djelovanju.',
    block3:
      'Ako ste mlađi od 18 godina, morate dobiti dopuštenje roditelja ili pravnih zastupnika da koristite uslugu. Ako koristite uslugu u ime druge osobe ili tvrtke, morate biti ovlašteni da prihvatite ove uvjete u njihovo ime. Prilikom registracije računa morate pružati točne i potpune informacije. Ne smijete pružati svoje pristupačne podatke ili račun nikome izvan vaše organizacije, a odgovorni ste za sve aktivnosti provedene pomoću vaših podataka.',
    block4:
      '(a) Korištenje usluge. Možete pristupiti Usluzi prema ovim uvjetima, a mi vam dodjeljujemo neisključno pravo na korištenje Usluge. Prilikom korištenja Usluge, morat ćete postupati u skladu s ovim uvjetima i svim primjenjivim zakonima. Mi i naši podružnici posjedujemo sva prava, naslova i interese u Usluzi.',
    block5:
      '(b) Povratne informacije. Dobrodošli su nam povratne informacije, komentari, ideje, predlozi i poboljšanja. Ako dostavite bilo kakav takav sadržaj, možemo ga koristiti bez ikakvih ograničenja i bez naknade za vas.',
    block6:
      '(c) Restrikcije. Ne smijete: (1) koristiti Uslugu na način koji krši, prisvaja ili narušava bilo kakva prava drugih osoba; (2) obavljati reverzno inženjerstvo, dekompiliranje, deasembliranje, prevodjenje ili na drugi način pokušavati otkriti izvorni kod ili osnovne komponente modela, algoritama i sustava Usluge (osim ako takve restrikcije zabranjuje primjena zakona); (3) koristiti rezultat Usluge za razvoj modela koji se natječu s Noamom; (4) izvaditi podatke ili rezultat iz Usluge korištenjem bilo kojih automatskih ili programskih metoda osim ako je to dopušteno putem API-ja, uključujući scraping, web harvesting ili web ekstrakciju podataka; (5) predstavljati rezultat Usluge kao umjetno generirani kada nije, ili na drugi način kršiti naše politike korištenja; (6) kupovati, prodavati ili prenosi API ključeve bez našeg prethodnog pristupa; ili (7) nam dostavljati bilo kakve osobne podatke djece mlađe od 13 godina ili primjenjive dobi digitalnog pristupa. Poštivat ćete sve ograničenja brzine i druge zahtjeve u našoj dokumentaciji.',
    block7:
      '(d) Usluge treće strane. Sve softver, usluge ili druga proizvoda treće strane povezane s Uslugom podliježu vlastitim uvjetima, a mi ne snosimo odgovornost za proizvode treće strane.',
    block8:
      '(a) Vaš sadržaj. Možete pružati unos („Unos“) usluzi i primati izlaz („Izlaz“) generiran i vraćen na temelju Unosa (zajednički nazvan „Sadržaj“). Između strana, u mjeri dopuštenom primjenjivim zakonima, vi posjedujete sve Unose. Noam može koristiti Sadržaj za pružanje i održavanje usluge, postupanje u skladu s primjenjivim zakonima te provođenje naših pravila. Vi ste odgovorni za Sadržaj, uključujući osiguravanje da on ne krši nikakva primjenjiva zakona ili ove uvjete.',
    block9:
      '(b) Točnost. Umjetna inteligencija i strojno učenje su brzo razvijajuća područja istraživanja. Stalno se trudimo poboljšati naš servis kako bi bio točniji, pouzdaniji, sigurniji i korisniji. S obzirom na vjerojatnosni karakter strojnog učenja, korištenje našeg servisa u nekim slučajevima može rezultirati netočnim ishodima, koji možda ne odražavaju točno stvarne osobe, mjesta ili činjenice. Trebate odgovarajuće procijeniti točnost bilo kojeg ishodnog rezultata temeljem svog uporabe, uključujući ručno pregledavanje rezultata.',
    subTitle1: 'Registracija i pristup',
    subTitle10: 'Djelomična važenja',
    subTitle2: 'Zahtjevi za korištenje',
    subTitle3: 'Sadržaj',
    subTitle4: 'Troškovi i plaćanje',
    subTitle5: 'Povjerljivost, sigurnost i zaštita podataka',
    subTitle6: 'Trajanje i prekid',
    subTitle7: 'Odgovornost za kompenzaciju; Isporištenja odgovornosti; Ograničenje odgovornosti',
    subTitle8: 'Upravno pravo i nadležnost',
    subTitle9: 'Opći uvjeti',
    title: 'Uvjeti korištenja',
    updateTime: 'Ažurirano: 15. ožujka 2024.',
  },
  trialModal: {
    btn: 'Započnite sada (samo 0,99 USD)',
    chat: 'ChatPDF',
    desc1: 'Nakon vašeg probnog razdoblja, naplaćivat će se godišnja naknada od 180 USD',
    desc2: 'Otkaži bilo kada',
    focus: 'Fokusiranje',
    hover: 'Prevod po prelazu miša',
    image: 'Prevod slike',
    installBtn: 'Instaliraj sada kako biste primili svoj poklon',
    memo: 'Upravljanje omiljenima',
    pdf: 'Paralelno prevođenje PDF-a',
    realtime: 'Brza prijevod',
    select: 'Prevod izbora riječi',
    title: 'Dobrodošlicni poklon',
    trialText: '7-dnevno probno korištenje',
    video: 'Video prijevod',
    videoSummary: 'Zaključak videa',
    web: 'Paralelno prijevod',
    webSummary: 'Web sažetak',
  },
  upgradeModal: {
    btn: 'Ažuriraj sada',
    chat: {
      free: 'Dosegli ste ograničenje ChatPDF-a',
      pro: 'Dosegli ste ograničenje ChatPDF-a za ovaj mjesec',
    },
    contactStr: 'Pričekajte sljedeći reset ili nas kontaktirajte na contact@noam.tools.',
    limitAlertStr: 'Dosegli ste limit besplatnog plana. Nadogradite za nastavak.',
    more: 'Pogledajte planove',
    pageLimit: { free: 'Dosegli ste ograničenje broja stranica PDF-a' },
    title: 'Podsjetnik',
    upgradeAlertStr: 'Dosegli ste ograničenje besplatnog plana. Nadogradite kako biste nastavili.',
    upload: {
      free: 'Dosegli ste svoj limit prevođenja PDF datoteka',
      pro: 'Dosegli ste svoj limit prevoda PDF-a za ovaj mjesec',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Pridruži se sada',
      label: 'Prednosti za nove korisnike:',
      remain: 'Samo 30 preostalo',
      text: 'Samo 100 mjesta dostupno! Zauzmite svoje odmah!',
    },
  },
  aiPdfTranslator: {
    title: 'Besplatan AI prevoditelj PDF-a: Prevedite PDF s usporedbom na bilo koji jezik',
    desc: 'Lako prevedite PDF datoteke na bilo koji jezik pomoću umjetne inteligencije. Usporedite izvornji i prevedeni tekst strana uz stranu, brzo i besplatno.',
    keywords: 'GPT-4、AI Asistent、Prijevod、Sažetak、Fokus、ChatPDF、Bilješka、učinkovitost',
    sourceToTarget: {
      title: 'Besplatan alat za prevođenje PDF-a: besplatno prevedite {{source}} u {{target}}',
      desc: 'Prevedite svoje PDF datoteke s bilo kojeg izvornog jezika na vaš željeni jezik besplatno. Brza, točna i sigurna prevodjenja PDF datoteka podržana naprednom umjetnom inteligencijom.',
    },
    headerIntroduce: {
      title: 'Noam: Više od samo online prijevoda',
      introduce1: {
        title: 'Noam · Čitač PDF-a',
        desc: '✨Usporedna prijevod + AI Q&A. Brzo i točno prevedite PDF-ove u vaš ciljani jezik. Slobodno postavljajte pitanja o sadržaju kako biste dublje razumjeli svoje PDF datoteke.',
      },
      introduce2: {
        title: 'Noam · Ekstenzija za usporedno prijevod',
        desc: '👏Riješite sve vaše potrebe za prevođenje web stranica:',
        detail1: { title: 'Prevod web stranice:', desc: 'Dvjejezični prikaz jednim pored drugog' },
        detail2: { title: 'Prevod riječi:', desc: 'Brza prevodba s jednim klikom' },
        detail3: { title: 'Brza prijevod:', desc: 'Prevedite riječi ili rečenice odmah.' },
        detail4: { title: 'Prevođenje slika:', desc: 'Zamijenite slike prevedenim.' },
        detail5: { title: 'Prevođenje videa:', desc: 'Dvjezični podnaslovi za bolje gledanje.' },
        footer:
          'Iskoristite više čitanje podržanih umjetnom inteligencijom značajki za pametniju prevodjenje!',
      },
    },
    subtitle: 'Besplatno prevođenje PDF-a online',
    introduce: {
      module1: {
        detail1: {
          title: 'Stvarno vrijeme strana uz stranu prevod PDF-a',
          desc1:
            'Odmah prikaži izvornu i prevedenu sadržaj u sinkroniziranom, strana uz stranu rasporedu',
          desc2: 'Bez napora usporedite obje verzije s sinkroniziranim skrolanjem',
          desc3: 'Održavajte identično formatiranje za dosljedno iskustvo čitanja',
        },
        detail2: {
          title: 'Točan poravnanje i provjera sadržaja',
          desc1: 'Savršeno poravnanje između izvornog i prevedenog teksta za jednostavnu provjeru',
          desc2: 'Svaki segment sadržaja se precizno podudara u obje verzije',
          desc3: 'Brzo prepoznajte i riješite nesrazmjere u prijevodu za pouzdane rezultate',
        },
      },
      module2: {
        detail1: {
          title: 'Višestruki napredni AI modeli za precizno prevođenje',
          desc1:
            'Odaberite među vodećim AI modelima kako biste prilagodili svoje zahtjeve za prijevod',
          desc2: 'Osigurajte optimalne rezultate za različite vrste dokumenata i industrije',
          desc3: 'Fleksibilni modeli opcija nude prilagođena rješenja za svaku situaciju',
        },
        detail2: {
          title: 'Napredna umjetna inteligencija za prijevod svih vrsta sadržaja',
          desc1: 'Naš moćan AI model osigurava visoku točnost i razumijevanje prirodnog jezika',
          desc2: 'Lako rukuje tehničkim, akademskim i kreativnim dokumentima',
          desc3: 'Donosi pouzdana rezultata za sve vaše potrebe u prevodu',
          desc4: 'Inteligentna prilagodba različitim tipovima sadržaja za optimalnu performansu',
        },
      },
      module3: {
        detail1: {
          title: 'Inteligentna Interakcija s Dokumentima',
          desc1:
            'Bez muke chatajte s vašim PDF-ovima i prezentacijskim datotekama pomoću naprednog umjetnog inteligencije',
          desc2: 'Brzo postavite pitanja o sadržaju dokumenta i primite točne odgovore',
          desc3: 'Brzo generirajte sažeta sažetka dugih dokumenata',
        },
        detail2: {
          title: 'Dubinska analiza sadržaja i bezprekidan integracija',
          desc1:
            'Izvuci ključne informacije i analiziraj složene podatke uz razumijevanje podržano umjetnom inteligencijom',
          desc2: 'Dobijte uvide u tehničke, akademske ili kreativne materijale',
          desc3:
            'Besprekorno se integrira s našim prevoditeljem PDF-a za potpun rješenje za upravljanje dokumentima',
        },
      },
      module4: {
        detail1: {
          title: 'Iza Translacije PDF-a: Sve u Jednom Rješenju za Prevođenje Web Stranica',
          desc: 'Otkrijte naš moćan dodatak za strana uz stranu prevod, dizajniran za svaku online čitanju scenariju.',
          desc1:
            'Prevođenje web stranica: Uživajte u dvojezičnom sadržaju s sinkroniziranim prikazom strana uz stranu',
          desc2: 'Prijevod riječi: Brzo prevedite istaknute riječi jednim klikom',
          desc3:
            'Brza prijevod: Prijevodite bilo koji tekst ili rečenicu odmah za brzo razumijevanje',
          desc4: 'Prevođenje slika: Automatski zamijeni izvornje slike s prevedenim verzijama',
          desc5:
            'Prevod videozapisa: Gledajte videozapise s dvojezičnim podnaslovima za poboljšanu iskustvo',
        },
      },
    },
    question: {
      title: 'Često postavljana pitanja',
      answer1: {
        title: 'Je li Noam PDF Translator besplatan za prevođenje PDF datoteka?',
        content:
          'Da, možete prevesti PDF datoteke besplatno pomoću Sider PDF Translatora! Nudimo besplatni kvotu od 5.000 tokena, što je dovoljno za prevođenje većine PDF dokumenata koji se obično nalaze na tržištu. Ako trebate prevesti veće datoteke ili trebate napredne značajke, možete odabrati nadogradnju na naše premium planove za još više mogućnosti.',
      },
      answer2: {
        title: 'Koliko je točan prevoditelj Noam PDF?',
        content:
          'Prevoditelj Noam PDF pruža vrlo točne prevode koristeći naprednu AI tehnologiju i duboko razumijevajući kontekst vaših dokumenata. Iako nijedan automatizirani prevod nije savršen, naš prikaz strana uz stranu omogućuje vam lako pregledavanje i poboljšanje svakog prevoda, osiguravajući da konačni rezultat zadovolji vaše kvalitativne očekivanja. Iskusite pouzdan i precizan prevod PDF dokumenata s Noamom.',
      },
      answer3: {
        title: 'Mogu li prevesti skenirane PDF datoteke?',
        content:
          'Da, možete prevesti skenirane PDF datoteke pomoću naše ugrađene OCR (Optičko prepoznavanje znakova) tehnologije. Naš sustav automatski izvlači tekst iz skeniranih dokumenata i PDF-a temeljenih na slikama, a zatim prevede sadržaj za vas. To osigurava da se čak i neuređivi ili samo slikasti PDF-ovi mogu točno prevesti.',
      },
      answer4: {
        title: 'Koliko dugo traje prijevod?',
        content:
          'Prevođenje je brzo i učinkovito — većina dokumenata se obrađuje u roku od nekoliko sekundi do nekoliko minuta, ovisno o njihovoj duljini i složenosti. Na primjer, standardni PDF s 10 stranica obično traje manje od 2 minute da se prevede. Uživajte u brzoj izdaji za sve vaše potrebe prevođenja dokumenata!',
      },
      answer5: {
        title: 'Mogu li zadržati strana uz stranu prikaz za čitanje?',
        content:
          'Da, uvijek možete čitati svoje dokumente jedan pored drugog. Ovaj raspored vam omogućuje jednostavno uspoređivanje izvornog i prevedenog sadržaja, osiguravajući glatko i učinkovito čitanje.',
      },
    },
    freeTrial: 'Besplatna probna verzija',
    toLanguage: { title: 'PDF AI prevodne parove', item: '{{source}} u {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Blog',
      pricing: 'Cijena',
      button: 'Prevedi sada',
      features: 'Svojstva',
      faq: 'Često postavljana pitanja',
    },
    hero: {
      upload: {
        title: 'Postavite svoj PDF',
        highlight: 'Kliknite za pregled',
        max: 'Max',
        desc: 'ili povucite i ispustite',
      },
      to: 'u',
      pill: 'AI-om pogonjeni prevodilac PDF-a',
      title: 'Besplatni prevoditelj PDF-a',
      desc: 'Brze, točne prevode koji čuvaju izvornu izgled. Noam AI podržava OCR i prikaz pored pored.',
      support: 'Podrška za OCR',
      free: 'Besplatna probna verzija',
      model: 'GPT-4 i Claude',
      translated: 'Prevedeno od strane Noama',
      complete: 'Prevođenje završeno',
    },
    ticker: {
      pdf: 'Prevod PDF-a',
      ocr: 'OCR tehnologija',
      format: 'Zadržavanje formata',
      multi: 'Višejezično',
      side: 'Strana uz stranu',
      chat: 'Chat s PDF-om',
      web: 'Web prijevod',
      secure: 'Sigurno i Privatno',
    },
    comparison: {
      bad: {
        title: 'Standardna prijevod',
        head: 'Izgubljena Formatiranje i Kontekst',
        text1: 'Greška: raspored je poremećen. Slike su pogrešno postavljene.',
        text2: 'Tekst se preklapa i fonti su nesrazumljivi. Teško čitati i neprofesionalno...',
      },
      dump: { title: 'Izlučak običnog teksta' },
      good: {
        title: 'Prevođenje Noam AI',
        tag: 'Savršen rezultat',
        sub: 'Savršeno Formatiranje, Svjesno Konteksta',
      },
      title: 'Zašto odabrati Noam AI?',
      desc: 'Prestanite se mučiti s kopiranjem i lijepljenjem pri prevodu. Iskusite razliku između standardnih alata i našeg AI-om pogonanog kontekstno svjesnog prevoda.',
    },
    showcase: {
      kicker: 'PODRŽANE DOKUMENTACIJE',
      title2: 'Bilo koji jezik',
      title1: 'Bilo koji dokument',
      carousel2: 'Arhitektura',
      carousel4: 'Medicina',
      carousel1: 'Umjetnost',
      carousel3: 'Akademski časopis',
      note: 'Lako rukujte tehničkim, akademskim i kreativnim dokumentima.',
      carousel5: 'Financije',
      carousel6: 'Zakon',
      carousel7: 'Ugovor',
      carousel8: 'Politika',
    },
    features: {
      big: {
        title: 'Napredni AI modeli (GPT-4, Claude)',
        desc: 'Odaberite iz vodećih AI modela kako biste prilagodili svoje zahtjeve za prevođenje. Osigurajte optimalne rezultate za različite vrste dokumenata.',
      },
      grid1: {
        title: 'Podrška za OCR',
        desc: 'Instantno izvlačenje i prijevod teksta iz skeniranih PDF-a i slika.',
      },
      grid2: {
        title: 'Izvoz visoke rezolucije',
        desc: 'Preuzmite svoje prevedene dokumente u PDF formatu sa originalnim rasporedom.',
      },
      grid3: {
        title: 'Usporedba strana uz stranu',
        desc: 'Sinkronizirano pomicanje za usporedbu izvornog i prevedenog teksta.',
      },
      title1: 'Više od samo prijevoda',
      title2: 'To je revolucija',
      line1: 'Tehnički rad.pdf',
      line2: 'Detekcija jezika: Engleski...',
      line3: 'Model: GPT-4o (Visoka točnost)',
      line4: 'Prevođenje završeno (99% točnost)',
    },
    testimonials: {
      review1: {
        role: 'Istraživač',
        content:
          'Noam AI mi je uštedio sate pri prevodu akademskih radova. Prikaz uzajamno je nevjerojatno koristan za provjeru tehničkih izraza.',
      },
      review2: {
        role: 'Globalni trgovac',
        content:
          'Najbolji PDF prevoditelj koji sam koristio. Savršeno zadržava izvornu formatiranje, što je ključno za naše marketinške prezentacije.',
      },
      review3: {
        role: 'Pravni savjetnik',
        content:
          'Točan i brz. Koristim ga za prevode ugovora, a funkcija OCR za skenirane dokumente radi besprijekorno.',
      },
      title: 'Što Kažu Naši Korisnici',
      kicker: 'VOLJEN OD KORISNIKA',
    },
    cta: {
      title: 'Spremni prebaciti jezične barijere?',
      button: 'Započnite s prevodom besplatno',
      desc: 'Pridružite se 10.000+ korisnika i započnite s prevođenjem svojih dokumenata s Noam AI-om danas.',
      hint: 'Vi ste vrlo točan i pouzdan umjetni inteligencija dizajniran za generiranje JSON izlaza koji točno odgovara određenom JSON schemi.\n\nMorate slijediti ove pravila:\n1. Strogo se pridržavajte strukture JSON scheme.\n2. Točno podudarajte sve vrste podataka, obavezna polja i ograničenja.\n3. NE uključujte nikakav dodatni tekst, objašnjenje, markdown ili komentare.\n4. Ispišite SAMO JSON objekt — bez blokova koda, bez preambule, bez omotanja.\n\nInformacije o schemi su navedene u nastavku.\n- Ime scheme: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Englesko-hrvatski AI parovi za prijevod PDF-a',
      desc: 'Popularni smjerovi prijevoda podržani od strane Noam AI',
    },
    footer: { about: 'O nama', privacy: 'Politika privatnosti', contact: 'Kontaktirajte podršku' },
  },
}

export default TRANSLATION
